import React from 'react';
import PropTypes from 'prop-types';

const CurrencyOption = (props) => {
    return(
        <option value={props.currency}>
            {props.currency}
        </option>
    )
}

export default CurrencyOption;

CurrencyOption.propTypes = {
    currency: PropTypes.string.isRequired,
    disabled: PropTypes.any,
    selected: PropTypes.any
}